module.exports = {"433130001":"民安街道","433130002":"华塘街道","433130004":"兴隆街道","433130005":"石羔街道","433130104":"洗车河镇","433130110":"石牌镇","433130112":"茨岩塘镇","433130113":"红岩溪镇","433130114":"靛房镇","433130115":"苗儿滩镇","433130116":"里耶镇","433130117":"桂塘镇","433130118":"召市镇","433130119":"洗洛镇","433130120":"水田坝镇","433130121":"农车镇","433130200":"洛塔乡","433130210":"大安乡","433130220":"内溪乡","433130236":"咱果乡","433130237":"茅坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433130.json
// module id = 1773
// module chunks = 0